import { Export, MagnifyingGlass } from '@phosphor-icons/react';
import { Button, Flex, Input } from 'antd';
import { CustomerSearchInput } from '@page-components/crm/CustomerSearch';
import { IconSizes } from '@utility/constants/style-contants';

export type ReplenishmentListToolbarProps = {
  viewIgnoredItems: boolean;
  onToggleIgnoredItems: () => void;
  downloadLoading: boolean;
  onExport: () => void;
  onCustomerSelect: (customer: { customerOrganizationId: string }) => void;
  search: string;
  onSearchChange: (value: string) => void;
};

export function ReplenishmentListToolbar({
  viewIgnoredItems,
  onToggleIgnoredItems,
  downloadLoading,
  onExport,
  onCustomerSelect,
  search,
  onSearchChange,
}: ReplenishmentListToolbarProps) {
  return (
    <Flex align="center" justify="space-between" gap={16} style={{ width: '100%' }}>
      <Button onClick={onToggleIgnoredItems}>
        {viewIgnoredItems ? 'View Active Items' : 'View Ignored Items'}
      </Button>
      <Flex align="center" gap={8} wrap="nowrap">
        <Button loading={downloadLoading} icon={<Export size={16} />} onClick={onExport}>
          Export
        </Button>
        <CustomerSearchInput style={{ width: 200 }} onResultClick={onCustomerSelect} />
        <Input
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          placeholder="Search title, SKU..."
          allowClear
          prefix={<MagnifyingGlass size={IconSizes.small} />}
          style={{ width: 200 }}
        />
      </Flex>
    </Flex>
  );
}
